import RestClient from '../RestClient/RestClient';
import { RestConfig, getHostConfig } from '../Common/RestConfig';
import { getChannel } from '../Common/CommonHelper';
import AccountApiConstants from './AccountApiConstants';

/**
 * Function to update passed config
 * based on action object
 * @param {Object} obj : Takes action object
 * @returns {Object}  configObject : update config object
 */
export const getOmniWalletCommonConfig = (obj) => {
    let config = {};
    config = RestConfig.v1OmniWalletConfig();

    // addding channel header as per contract
    const context = RestClient.getContext();
    config.channel = getChannel(context);

    config.accessToken = obj.accessToken;
    config = getHostConfig(config);
    return config;
};

export const getAccountV5Config = (obj) => {
    let config = RestConfig.v5AccountConfig();
    config.accessToken = obj.accessToken;
    config = getHostConfig(config);
    return config;
};

export const getOrdersListConfig = (obj, versionConfig) => {
    let config = versionConfig;
    config.url = `${AccountApiConstants.ORDER_URL}`;
    config.accessToken = obj.accessToken;
    config.params = {
        custAccountId: obj.accountId,
        dateFrom: obj.payload.dateFrom,
        dateTo: obj.payload.dateTo,
    };
    config.xClientOrigin = 'CAM';
    config.xGetLines = 'Y';
    config.xGetTracking = 'Y';
    config = getHostConfig(config);
    return config;
};

export default {
    getOmniWalletCommonConfig,
    getOrdersListConfig,
};
